import { showToast, showLoadingToast, showDialog, closeDialog } from 'vant'
import { getQueryJson } from '@/common/utils/url.js'

export default () => {
  window.urlParams = getQueryJson()
  window.showToast = showToast
  window.showLoadingToast = showLoadingToast
  window.showDialog = showDialog
  window.closeDialog = closeDialog
}
